export default __webpack_public_path__ + "static/media/cross-boarder.01e1113b.jpg";